import { useQuery } from 'react-query';

import { PlanUnitLink } from '../../types';

import { toOptions } from 'utils/toOptions';

import { getClusters, getEmployers } from 'RestAPIs/admin';

export const useGetEntities = (mode?: PlanUnitLink) =>
  useQuery(['entities'], async () => {
    if (mode === PlanUnitLink.CLUSTER) {
      const { data } = await getClusters();

      return toOptions(data, 'clusterId', 'name');
    } else if (mode === PlanUnitLink.EMPLOYER) {
      const { data } = await getEmployers();

      return toOptions(data, 'employerId', 'name');
    }
  });
